export default "__VITE_ASSET__ClRWU7iz__"